import { MedicationTypeEnum } from "common/enums/MedicationTypeEnum";

export interface MedicationSearchResultType {
  readonly name: string;
  readonly type: MedicationTypeEnum;
  readonly cheapCategoryInfo?: string;
  readonly reimbursementCodes: Array<string>;
  readonly price: number;
  readonly otc?: boolean;
  readonly dto?: object;
}

export class MedicationSearchResult implements MedicationSearchResultType {
  name: string;
  type: MedicationTypeEnum;
  cheapCategoryInfo?: string;
  reimbursementCodes: Array<string>;
  price: number;
  otc?: boolean;
  dto?: object;

  constructor(data?: MedicationSearchResultType) {
    this.name = "";
    this.type = MedicationTypeEnum.FREETEXT;
    this.cheapCategoryInfo = "";
    this.reimbursementCodes = [];
    this.price = -1;
    data && Object.assign(this, data);
  }
}
